export class DeliveryMethod {
    id: number;
    name: string;
    
    constructor (data){
        this.id = data.deliverymethod_pk;
        this.name = data.delivery_method;
    }
}
